import React from 'react';
import './NotificationsList.css';

const notifications = [
  {
    title: 'Payment Transaction Alert',
    message: 'Your payment is successful',
    time: 'Aug-27-2025 08:59 AM',
  },
  {
    title: 'Payment Successful',
    message: 'Your payment of $1.00 has been successfully processed. Thank you.',
    time: 'Aug-27-2025 09:00 AM',
  },
  {
    title: 'Payment Successful',
    message: 'Your payment of $2.00 has been successfully processed. Thank you.',
    time: 'Aug-11-2025 12:28 PM',
  },
];

const NotificationsList = () => {
  return (
    <div className="notifications-wrapper">
      <div className="notifications-header">
        <div className="title">
          Unread <span className="badge">6</span>
        </div>
        <div className="pagination">
          <span>1-10 of 19</span>
          <span className="nav">{'<'}</span>
          <span className="nav">{'>'}</span>
          <a className="clear-all" href="#">Clear all</a>
        </div>
      </div>

      {notifications.map((n, index) => (
        <div className="notification-card" key={index}>
          <div className="notification-left">
            <div className="icon-placeholder">🔔</div>
            <div className="notification-info">
              <p className="message">{n.message}</p>
              <p className="title">{n.title}</p>
              <p className="reported-time">Reported time</p>
              <p className="timestamp">{n.time}</p>
            </div>
          </div>
          <div className="notification-right">
            <span>{n.time}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationsList;
